import i18n from '@/plugins/i18n';
export default function () {
  return [
        {
            title: i18n.t('general_information'),
            title_short: i18n.t('general'),
            slug: 'general_information',
            permission: 'staff_show',
            show: true,
        },
        {
            title: i18n.t('Emergency Contact Information'),
            title_short: i18n.t('Emergency Contact Information'),
            slug: 'emergency_contact_information',
            permission: 'staff_show',
            show: true,
        },
        {
            title: i18n.t('documents'),
            title_short: i18n.t('documents'),
            slug: 'documents',
            permission: 'staff_show',
            show: true,
        },
        {
            title: i18n.t('adjunct_information'),
            title_short: i18n.t('adjunct_information'),
            slug: 'adjunct',
            permission: 'staff_show',
            show: true,
        },
        {
            title: i18n.t('course_information'),
            title_short: i18n.t('course_information'),
            slug: 'course_information',
            permission: 'staff_show',
            show: true,
        },
        {
            title: i18n.t('hr_information'),
            title_short: i18n.t('hr_information'),
            slug: 'hr_information',
            permission: 'staff_show',
            show: true,
        },

    ];

}


